var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Bfhs'),_c('TrendingMixes'),_c('HomeRadio'),_c('LatestMixes'),_c('FeaturedPlaylists'),_c('FeaturedCharts'),_c('TrendingDjs')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }